import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {Box, Divider, IconButton, Tooltip} from '@mui/material';
import {useState} from 'react';

import {ExportField} from '../../interfaces/Export';
import ModalFixed from '../common/ModalFixed';
import AMSLocationHistoryExportExcel from './AMSLocationHistoryExportExcel';

interface Props {
  value?: {
    exportFields?: ExportField[];
    params?: {
      date_start?: string;
      date_end?: string;
      page?: number;
      limit?: number;
      order?: string;
      dir?: 'ASC' | 'DESC';
      status?: 'active' | 'inactive' | 'unacknowledged' | 'all';
    };
    sensorId?: string;
  };
}

const AMSLocationHistoryExportButton = ({value}: Props) => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Tooltip title="Export">
        <FileDownloadIcon onClick={() => setIsOpened(true)} />
      </Tooltip>

      {isOpened ? (
        <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            gap={3}
            p={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" alignItems="center" width="100%" gap={1.5}>
                <FileDownloadIcon sx={{color: 'primary.main'}} />
                <Box fontSize={24}>Export AMS Location History</Box>
              </Box>
              <IconButton onClick={() => setIsOpened(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              position="relative"
              gap={3}
            >
              <Divider>Export</Divider>
              <AMSLocationHistoryExportExcel value={value} />
            </Box>
          </Box>
        </ModalFixed>
      ) : null}
    </>
  );
};

export default AMSLocationHistoryExportButton;
